/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:17:18
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-09 15:04:57
 */
class defineMath {
    constructor(t = 0, e = 0) {
        this.x = t;
        this.y = e
    }
    add(t) {
        this.x += t.x;
        this.y += t.y
    }
    sub(t) {
        this.x -= t.x;
        this.y -= t.y
    }
    mult(t) {
        this.x *= t;
        this.y *= t
    }
    vmult(t) {
        this.x *= t.x;
        this.y *= t.y
    }
    div(t) {
        this.x /= t;
        this.y /= t
    }
    mag() {
        return Math.sqrt(this.x * this.x + this.y * this.y)
    }
    norm() {
        const magnitude = this.mag();
        if (magnitude !== 0) {
            this.div(magnitude);
        }
    }
    limit(t) {
        if (this.mag() > t){
            this.norm();
            this.mult(t)
        }
    }
    static add(position1, position2) {
        return new defineMath(position1.x + position2.x, position1.y + position2.y)
    }
    static sub(position1, position2) {
        return new defineMath(position1.x - position2.x, position1.y - position2.y)
    }
    static div(position1, position2) {
        return new defineMath(position1.x / position2, position1.y / position2)
    }
    static get(position1) {
        return new defineMath(position1.x, position1.y)
    }
}
class Ball {
    constructor() {
        this.free = true;
        this.grav = new defineMath(0, 1.1);
        this.pos = new defineMath();
        this.velocity = new defineMath();
        this.acceleration = new defineMath();
        this.frame = 0;
    }
    /**
     * 初始化球
     * @param {*} data 
     */
    init(data) {
        Object.assign(this, data); // 使用 Object.assign 赋值
    
        this.free = false;
        this.grav = new defineMath(0, 1.1);
        this.pos = new defineMath(data.xp, -10);
        this.velocity = new defineMath();
        this.acceleration = new defineMath(); 
        this.frame = 0;
    }
    /**
     * The function "applyForce" adds a force divided by the mass to the acceleration.
     * @param t - The parameter "t" represents the time interval over which the force is applied.
     */
    applyForce(time) {
        if (!this.acceleration) {
            this.acceleration = new defineMath();
        }
        this.acceleration.add(defineMath.div(time, this.mass))
    }
    /**
     * 更新小球的状态(位置、速度、碰撞检测等)
     * @param {*} t 
     * @returns 
     */
    update(t) {
        let collidedObject = null;
    
        // 更新帧计数
        this.frame++;
    
        // 应用重力
        this.applyForce(this.grav);
    
        // 更新速度和位置
        this.velocity.add(this.acceleration);
        this.pos.add(this.velocity);
    
        // 重置加速度
        this.acceleration.mult(0);
    
        // 检测碰撞
        t.forEach(object => {
            const collisionInfo = this.getCollide(this, object);
            
            if (collisionInfo !== undefined) {
                collidedObject = object;
                collidedObject.risk = this.risk;
    
                const { diff, min, mag } = collisionInfo;
                diff.norm();
                diff.mult(min - mag);
                this.pos.add(diff);
    
                const direction = defineMath.sub(this.pos, object.pos);
                direction.norm();
                direction.mult(this.velocity.mag());
                direction.mult(this.densety);
                this.velocity = direction;
            }
        });
    
        // 应用摩擦力
        this.velocity.vmult(this.friction);
    
        // 检查是否超出边界
        if (this.pos.y > this.maxY) {
            this.endFun(this);
        }
        return collidedObject;
    }
    /**
     * 检测球跟障碍物碰撞
     * @param {*} t 
     * @param {*} e 
     * @returns 
     */
    getCollide(t, e) {
        const distanceVector = defineMath.sub(t.pos, e.pos);
        const combinedRadius = t.radius + e.radius;
        const distanceMagnitude = distanceVector.mag();
    
        if (distanceMagnitude < combinedRadius) {
            return {
                diff: distanceVector,
                min: combinedRadius,
                mag: distanceMagnitude
            };
        }
    }
}
class RiskTrack {
    init(ball) {
        this.pos = defineMath.get(ball.pos),
            this.radius = ball.radius * 2.2,
            this.alpha = .4,
            this.free = false,
            ball.isFx = true,
            this.ball = ball,
            this.mainColor = {
                low: "76, 191, 255",
                medium: "194, 255, 139",
                high: "254, 227, 83"
            }[ball.risk]
    }
    /**
     * The "update" function decreases the alpha value, increases the radius, updates the color of the
     * object, and sets the "free" and "isFx" properties based on the alpha value.
     * @param t - The parameter "t" is a function that takes a color value as an argument and returns a
     * function that can be used to update the color of an object.
     */
    update(t) {
        // 更新透明度和半径
        this.alpha -= .03;
        this.radius += .3;
    
        // 绘制主颜色
        t(`rgba(${this.mainColor}, ${this.alpha + .5}`)({
            ...this,
            radius: this.ball.radius
        });
    
        // 绘制白色
        t(`rgba(255, 255, 255, ${this.alpha})`)(this);
    
        // 检查透明度是否小于 0
        if (this.alpha < 0) {
            this.free = true;
            this.ball.isFx = false;
        }
    }
}

class nt {
    constructor(t, e) {
        this.pos = new defineMath(t, e);
        this.radius = 7 + Math.random() * 10;
        this.r8 = this.radius / 8;
        this.velocity = new defineMath();
        this.acceleration = new defineMath();
        
        // 确保 alpha 值在合理范围内
        this.alpha = Math.max(0.15 + Math.random(), 0.3);
        this.alphaVector = Math.random() > 0.5 ? 0.01 : -0.01;
    
        // 随机生成目标位置的辅助函数
        const randomOffset = (min, max) => {
            const ceilMin = Math.ceil(min);
            const floorMax = Math.floor(max);
            return Math.random() * (floorMax - ceilMin) + ceilMin;
        };
        
        // 定义目标位置的范围
        const minOffset = 5;
        const maxOffset = 8;
    
        // 创建目标位置并打乱
        this.targets = this.shuffle([
            { pos: { x: t + randomOffset(minOffset, maxOffset) * -1, y: e + randomOffset(minOffset, maxOffset) * -1 } },
            { pos: { x: t + randomOffset(minOffset, maxOffset) * -1, y: e + randomOffset(minOffset, maxOffset) } },
            { pos: { x: t + randomOffset(minOffset, maxOffset), y: e + randomOffset(minOffset, maxOffset) * -1 } }
        ]);
    
        this.currTarget = 0;
        this.target = this.getTarget();
    }
    shuffle(data) {
        let len = data.length;
    
        while (len > 0) {
            const randomIndex = Math.floor(Math.random() * len);
            len--;
    
            // 交换元素
            [data[len], data[randomIndex]] = [data[randomIndex], data[len]];
        }
    
        return data;
    }
    /**
     * 碰撞
     * @param {*} t 
     * @param {*} e 
     * @returns 
     */
    getCollide(t, e) {
        const a = defineMath.sub(t.pos, e.pos);
        const i = 4;
        return a.mag() < i;
    }
    getTarget() {
        this.currTarget++;
        if (this.currTarget >= this.targets.length) {
            this.currTarget = 0;
        }
        return this.targets[this.currTarget];
    }
    applyForce(t) {
        this.acceleration.add(defineMath.div(t, 1))
    }
    /**
     * 计算并更新状态
     * @param {*} ctx 
     * @param {*} e 
     */
    update(ctx, e) {
        if (e) {
            // 更新透明度
            this.alpha += this.alphaVector;
            if (this.alpha < 0.5 || this.alpha > 1) {
                this.alphaVector *= -1;
            }
    
            // 计算力和位置
            const force = defineMath.sub(this.pos, this.target.pos);
            force.limit(1);
            force.mult(-0.02);
            this.applyForce(force);
            this.velocity.add(this.acceleration);
            this.pos.add(this.velocity);
            this.acceleration.mult(0);
    
            // 检测碰撞并更新目标
            if (this.getCollide(this, this.target)) {
                this.target = this.getTarget();
            }
        }
    
        // 计算半径并设置最小值
        let radius = this.r8 * this.alpha;
        radius = Math.max(radius, 0.3);
    
        // 绘制圆形
        this.cDro(ctx, `rgba(0, 28, 255, ${0.4 * this.alpha})`, "rgba(0, 28, 255, 0)", 2, radius * 8);
        this.cDro(ctx, `rgba(159, 159, 255, ${0.6 * this.alpha})`, "rgba(0, 28, 255, 0)", radius, radius * 2);
        this.cDro(ctx, `rgba(255, 255, 255, ${0.5 + this.alpha})`, "rgba(255, 255, 255, 0)", radius / 4, radius / 2);
    }
    /**
     * 绘制碰撞时的径向渐变圆
     * @param {*} ctx 画布
     * @param {*} internalColor 内部颜色
     * @param {*} externalColor 外部颜色
     * @param {*} innerRadius 内半径
     * @param {*} outerRadius 外半径
     */
    cDro(ctx, internalColor, externalColor, innerRadius, outerRadius) {
        const { pos = {} } = this;
        const gradient = ctx?.createRadialGradient(pos.x, pos.y, innerRadius, pos.x, pos.y, outerRadius);
    
        // 添加颜色停止点
        if (gradient) {
            gradient.addColorStop(0, internalColor);
            gradient.addColorStop(1, externalColor);
        }
    
        // 设置填充样式并绘制圆形
        ctx.fillStyle = gradient || externalColor; // 如果没有渐变，则使用外部颜色
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, outerRadius, 0, Math.PI * 2);
        ctx.fill();
    }
}
// 画布大小阈值。大于428为pc；小于等于428为mobile
const widthThreshold = 428;

// 小球的填充颜色
const ballFillColor = {
    low: {
        color1: "#69F3FF",
        color2: "#4781FF"
    },
    medium: {
        color1: "#62CF03",
        color2: "#D4FE4B"
    },
    high: {
        color1: "#FFAB01",
        color2: "#FF4A01"
    }
}
/**
 * 绘制渐变效果
 * @param {*} canvas 
 * @returns 
 */
const createRadialGradient = canvas => ({ pos = {}, radius, color1, color2 }) => {
    if (!canvas) return;

    const radialGradient = canvas.createRadialGradient(
        pos.x, pos.y, radius * 0.5, // 内半径
        pos.x, pos.y, radius        // 外半径
    );

    radialGradient.addColorStop(0, color1);
    radialGradient.addColorStop(1, color2);

    canvas.fillStyle = radialGradient;
    canvas.beginPath();
    canvas.arc(pos.x, pos.y, radius, 0, Math.PI * 2);
    canvas.fill();
};
/**
 * 绘制小球
 * @param {*} context 
 * @returns 
 */
const drawBall = (context) => (color) => (circle) => {
    // 开始绘制路径
    context.beginPath();

    // 绘制圆形
    context.arc(circle.pos.x, circle.pos.y, circle.radius, 0, Math.PI * 2);

    // 设置填充颜色
    context.fillStyle = color;

    // 填充圆形
    context.fill();
};
const ballConfigs = {
    16: [() => import("../data/rows16_mob.js"), () => import("../data/rows16_big.js")],
    15: [() => import("../data/rows15_mob.js"), () => import("../data/rows15_big.js")],
    14: [() => import("../data/rows14_mob.js"), () => import("../data/rows14_big.js")],
    13: [() => import("../data/rows13_mob.js"), () => import("../data/rows13_big.js")],
    12: [() => import("../data/rows12_mob.js"), () => import("../data/rows12_big.js")],
    11: [() => import("../data/rows11_mob.js"), () => import("../data/rows11_big.js")],
    10: [() => import("../data/rows10_mob.js"), () => import("../data/rows10_big.js")],
    9: [() => import("../data/rows9_mob.js"), () => import("../data/rows9_big.js")],
    8: [() => import("../data/rows8_mob.js"), () => import("../data/rows8_big.js")]
};
// 初始化canvas
class PlinkoInit {
    constructor() {
        this.lgs = [];
        this.staticBalls = [];
        this.balls = [];
        this.fxs = [];
        this.defaultBallProps = null;
        this.xps = null;
        this.isBig = false;
    }
    init(t) {
        this.canvas = typeof t === 'string' ? document.getElementById(t) : t;
        if (!this.canvas) return false;
        this.ctx = this.canvas.getContext("2d");
        return true;
    }
    async newGame(rows) {
        this.isBig = this.getWD() > widthThreshold;
        this.resizeCanvas(this.getGameSize(this.isBig));
        let ballConfig = await ballConfigs[rows][Number(this.isBig)]();
        ballConfig = ballConfig.default;
        this.staticBalls = this.getStaticBalls(ballConfig, this.getRectSize(this.isBig));
        this.balls = []; // 小球集合
        this.fxs = [];
        this.defaultBallProps = this.getDefaultBallProps(rows, ballConfig);
        this.xps = ballConfig.xps;
        this.lgs = this.getLights(); // 发光粒子
    }
    /**
     * 更新画布中的动态元素(碰撞等)
     * @param {*} isAnimation 
     * @returns 
     */
    update(isAnimation) {
        const { ctx, canvas, staticBalls, balls } = this;
    
        // 清除画布
        if (ctx) {
            ctx.clearRect(0, 0, canvas?.width || 0, canvas.height);
        }
    
        // 更新每个 LGS 项
        this.lgs.forEach(item => {
            item.update(ctx, isAnimation);
        });
    
        let flag = false;
    
        // 更新小球
        balls.forEach(item => {
            if (item.free === false) {
                flag = true;
    
                // 检查碰撞到的障碍物
                const staticBall = item.update(staticBalls);
    
                // 绘制小球
                if (this.isBig || (!this.isBig && item.pos.y > 50)) {
                    createRadialGradient(ctx)({
                        ...item,
                        ...ballFillColor[item.risk]
                    });
                }
    
                // 添加效果
                if (staticBall && !staticBall.isFx) {
                    this.addFx(staticBall);
                }
            }
        });
    
        // 绘制静态小球
        staticBalls.forEach(item => {
            drawBall(ctx)("rgba(1,1,1,0.25)")({
                pos: {
                    x: item.pos.x,
                    y: item.pos.y + 4
                },
                radius: item.radius
            });
            drawBall(ctx)("#FFF")(item);
        });
    
        // 更新效果
        this.fxs.forEach(item => {
            if (!item.free) {
                item.update(drawBall(ctx));
            }
        });
    
        return flag;
    }
    /**
     * 添加小球
     * @param {*} index 对应倍数的下标
     * @param {*} endFun 结束回调
     * @param {*} risk 风险等级
     */
    addBall(index, endFun, risk) {
        // 查找是否有空闲的球
        let freeBall = this.balls.find(item => item.free);
        // 如果没有空闲的球，则初始化创建一个新的球
        if (freeBall === undefined) {
            freeBall = new Ball();
            this.balls.push(freeBall)
        }
        freeBall.init({
            ...this.defaultBallProps,
            endFun,
            xp: this.getXp(index),
            risk
        })
    }
    /**
     * 画布是否有非空闲的小球
     * @returns Boolean
     */
    hasBall() {
        return this.balls.some(item => item.free === false)
    }
    /**
     * 查找并初始化空闲的球
     * @param {*} staticBall 
     */
    addFx(staticBall) {
        // 查找一个可用的空闲球
        let freeBall = this.fxs.find(ball => ball.free);
    
        // 如果没有找到空闲球，则创建一个新的
        if (freeBall === undefined) {
            freeBall = new RiskTrack();
            this.fxs.push(freeBall);
        }
    
        // 初始化空闲球
        freeBall.init(staticBall);
    }
    /**
     * resize canvas尺寸大小
     * @param {Object} param0 宽、高
     */
    resizeCanvas({ width, height }) {
        if (this.canvas) {
            this.canvas.width = width;
            this.canvas.height = height;
        }
    }
    /**
     * 检查是否resize
     * @returns Boolean
     */
    checkResize() {
        return this.isBig && this.getWD() <= widthThreshold || !this.isBig && this.getWD() > widthThreshold
    }
    /**
     * 生成静态球障碍物
     * @param {*} param0 
     * @param {*} rectSize 
     * @returns 
     */
    getStaticBalls({ ballDistance, diameter, numRows, yBonus = 0, yMult = 1 }, rectSize) {
        const balls = [];
        let currentRowCount = 3;
    
        // 计算中心点坐标
        ballDistance += diameter;
        const startPosition = {
            x: (this.canvas?.width ?? 0) / 2 - ballDistance,
            y: rectSize.y + diameter / 2 + yBonus
        };
    
        for (let row = 0; row < numRows; row++) {
            for (let col = 0; col < currentRowCount; col++) {
                balls.push({
                    pos: {
                        x: startPosition.x + col * ballDistance,
                        y: startPosition.y
                    },
                    radius: diameter / 2
                });
            }
            // 更新起始位置
            startPosition.x -= ballDistance / 2;
            startPosition.y += ballDistance * yMult;
            currentRowCount++;
        }
    
        return balls;
    }
    /**
     * 生成发光粒子
     * @returns 
     */
    getLights() {
        const lights = [];
        const { width, height } = this.getGameSize(this.isBig);
    
        // 计算点与三角形的关系
        const isPointInTriangle = (point, [v1, v2, v3]) => {
            const area = (p1, p2, p3) =>
                (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
    
            const area1 = area(point, v1, v2);
            const area2 = area(point, v2, v3);
            const area3 = area(point, v3, v1);
    
            const hasNegative = area1 < 0 || area2 < 0 || area3 < 0;
            const hasPositive = area1 > 0 || area2 > 0 || area3 > 0;
    
            return !(hasNegative && hasPositive);
        };
    
        // 生成光源位置
        const generateLightPosition = (isLeftSide) => {
            const adjustedHeight = this.isBig ? height : height / 1.5;
            let position;
    
            const leftTriangle = [
                { x: 50, y: 50 },
                { x: width / 2.5, y: 50 },
                { x: 50, y: adjustedHeight }
            ];
    
            const rightTriangle = [
                { x: width - 50, y: 50 },
                { x: width - width / 2.5, y: 50 },
                { x: width - 50, y: adjustedHeight }
            ];
    
            do {
                position = {
                    x: Math.random() * width,
                    y: Math.random() * height
                };
            } while (!isPointInTriangle(position, isLeftSide ? leftTriangle : rightTriangle));
    
            return position;
        };
    
        // 生成24个光源
        for (let i = 0; i < 24; i++) {
            const { x, y } = generateLightPosition(i < 12);
            const light = new nt(x, y); // 假设 Light 是光源的构造函数
            lights.push(light);
        }
    
        return lights;
    }
    getGameSize(t) {
        return [{
            width: 428,
            height: 515
        }, {
            width: 682,
            height: 501
        }][Number(t)]
    }
    getRectSize(t) {
        return [{
            width: 396,
            height: 388,
            x: 16,
            y: 73
        }, {
            width: 450,
            height: 382,
            x: 116,
            y: 42
        }][Number(t)]
    }
    /**
     * 获取画布父节点的宽度
     * @returns 画布父节点的宽度
     */
    getWD() {
        // 获取画布对象
        const canvas = this.canvas;
        // 如果画布对象为空，则返回 undefined
        if (canvas === undefined) {
            return undefined;
        }
        // 获取画布父节点
        const parentNode = canvas.parentNode;
        // 如果画布父节点为空，则返回 undefined
        if (parentNode === undefined) {
            return undefined;
        }
        // 返回画布父节点的宽度
        return parentNode.offsetWidth;
    }
    /**
     * 设置小球的默认属性
     * @param {number} rows 
     * @param {*} param1 
     * @returns 
     */
    getDefaultBallProps(rows, { ballProp }) {
        const radius = (12 + 1.5 * (16 - rows)) / 2;
        const maxY = this.staticBalls[this.staticBalls.length - 1].pos.y + 15;
        return {
            ...ballProp,
            radius,
            maxY
        }
    }
    getXp(t) {
        const e = this.xps[t];
        return e[Math.floor(Math.random() * e.length)]
    }
}

export default {
    PlinkoInit
}